module.exports = __webpack_public_path__ + "img/map_9.4668a873.webp";